import {MaterialSource, MaterialType} from '@domain/materials'
import {useForm, UseFormReturn} from 'react-hook-form'

import {useUrlParam} from '../../../../../routing'

export type NewMaterialFormDefaultValues = {
  type: MaterialType | null
  name: string
  description: string
  source: MaterialSource | null
}

export const useNewMaterialForm = (): UseFormReturn<NewMaterialFormDefaultValues> => {
  const materialType = useUrlParam('materialType')

  const materialForm = useForm<NewMaterialFormDefaultValues>({
    mode: 'onSubmit',
    shouldFocusError: false,
    defaultValues: {
      type: materialType as MaterialType,
      name: '',
      description: '',
      source: null
    }
  })

  return materialForm
}
